import { createSelector } from '@ngrx/store';

export const getToastBannerState = createSelector(
    state => state['toastBanner'],
    (toastBannerProps) => toastBannerProps['type']
);

export const getToastBannerProps = createSelector(
    state => state['toastBanner'],
    (toastBannerProps) => toastBannerProps
);
